import { useTheme } from "@mui/material";
import { createSxStyles } from "@common/createSxStyles";

export const useRiskScoringFormStyles = () => {
    const theme = useTheme();
    return createSxStyles({
        // No alignItems override: grid items stretch by default, keeping the two columns equal height.
        columns: {
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: theme.spacing(4),
        },
        // Sections stack and size to their content; the exposure section only appears when exposure is measured,
        // so we don't force equal height (which would leave the small exposure box awkwardly stretched).
        leftColumn: {
            display: "flex",
            flexDirection: "column",
        },
        column: {
            display: "flex",
            flexDirection: "column",
            gap: theme.spacing(1),
        },
        calculatedRiskRow: {
            display: "flex",
            alignItems: "center",
            gap: theme.spacing(1),
            marginBottom: theme.spacing(2),
        },
        calculatedRiskLabel: {
            fontSize: "0.75rem",
            fontWeight: theme.typography.fontWeightBold,
            color: theme.palette.text.secondary,
        },
        unscored: {
            fontSize: "0.75rem",
            color: theme.palette.text.secondary,
        },
    });
};
